import { useQuery } from '@tanstack/react-query';
import { zohoKeys } from '../api/keys';
import { fetchZohoConfig, fetchZohoTicketFields } from '../api/requests';

/**
 * Loaded on demand (it calls Zoho). No retry: "not configured" is an answer,
 * and the builder falls back to typed API names.
 */
export function useZohoTicketFields(enabled: boolean) {
  return useQuery({
    queryKey: zohoKeys.ticketFields,
    queryFn: ({ signal }) => fetchZohoTicketFields(signal),
    enabled,
    staleTime: 10 * 60 * 1000,
    retry: false,
  });
}

export function useZohoConfig() {
  return useQuery({
    queryKey: zohoKeys.config,
    queryFn: ({ signal }) => fetchZohoConfig(signal),
  });
}
